import {Injectable} from "@angular/core";
import {OpenIdConfiguration, StsConfigLoader,} from "angular-auth-oidc-client";
import {combineLatest, map, Observable} from "rxjs";
import {environment} from "src/environments/environment";
import {OidcConfigService, TenantOidcConfig} from "./oidc-config.service";
import {OidcConfiguration} from "./oidc-configuration.enum";

@Injectable({
  providedIn: "root",
})
export class CustomStsConfigLoader extends StsConfigLoader {

  constructor(private readonly oidcConfigService: OidcConfigService) {
    super();
  }

  loadConfigs(): Observable<OpenIdConfiguration[]> {
    return combineLatest([
      this.oidcConfigService.getTenantConfig(environment.opco),
      this.oidcConfigService.getTenantConfig(OidcConfiguration.Auth0),
    ])
      .pipe(
        map(([auth0Config, opcoConfig]: [TenantOidcConfig, TenantOidcConfig]) => [
          this.mapConfig(auth0Config),
          this.mapConfig(opcoConfig)
        ])
      )
  }

  private mapConfig(config: TenantOidcConfig): OpenIdConfiguration {
    const redirectUrl = config.redirectUrl || `${globalThis.location.origin}/dashboard`;

    return {
      configId: config.name,
      authority: config.authority,
      clientId: config.clientID,
      redirectUrl,
      postLogoutRedirectUri: globalThis.location.origin + "/login",
      scope: config.scope || 'openid profile email',
      responseType: config.responseType,
      silentRenew: true,
      useRefreshToken: true,
      logLevel: 0,
    } as OpenIdConfiguration;
  }
}
